export default __webpack_public_path__ + "static/media/termsBgDec3.a146dc7b.png";